/*
 * WEBPACK BUNDLE ENTRY
 * THIS FILE IS THE BLUEPRINT FOR BUILDING THE /dist/bundle.js
 *
 * You can build this file with
 *
 *    $ npm run build
 *
 * from the project root.
 *
 */
(function() {
  require('./popup');
  require('./tac_update');
  require('./notify_parent_of_height');

  require('./jquery_ajax_setup');
  require('./jquery_pjax_init');

  window.neoquiz_clock = require('./quiz_clock');

}());
